import { render, staticRenderFns } from "./WidgetTypeSelector.vue?vue&type=template&id=d4ff7b6e&"
import script from "./WidgetTypeSelector.vue?vue&type=script&lang=js&"
export * from "./WidgetTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports